<template>
  <header v-if="isUpsellEditor" class="edit-topbar">
    <div class="edit-topbar-main">
      <button type="button" class="btn btn--ghost btn--back" @click="goBack">
        <ArrowLeftOutlined />
        <span>Back</span>
      </button>
      <h1 class="edit-title">Upsell Page Settings</h1>
    </div>
    <div class="edit-topbar-actions">
      <button
        type="button"
        class="btn btn--ghost"
        @click="funnelStore.requestUpsellReset"
      >
        Reset to Default
      </button>
      <button
        type="button"
        class="btn btn--ghost"
        @click="funnelStore.requestUpsellRefresh"
      >
        Refresh Preview
      </button>
      <SaveFunnel v-if="isPrefixActive('/funnel-')"/>
    </div>
  </header>

  <a-row v-else justify="space-between" align="middle"
         style="padding: 16px 40px; background: #fff; border-bottom: 1px solid #eee;">
    <!-- 左侧导航 -->
    <a-space v-if="!isFunnelDetail">
      <a-button v-for="item in navs" :key="item.key" type="default" :icon="item.icon"
                :class="{ 'ant-btn-primary': isPrefixActive(item.path) }"
                @click="go(item.path)"
                @mouseenter="onNavHover(item.path)"
                style="min-width: 120px; justify-content: flex-start;">
        {{ item.label }}
      </a-button>

      <a-dropdown>
        <template #overlay>
          <a-menu @click="onSubscriptionsMenuClick">
            <a-menu-item key="Reports" @mouseenter="onSettingsHover('/subscriptions/reports')">
              Reports
            </a-menu-item>
            <!-- <a-menu-item key="Analytics" @mouseenter="onSettingsHover('/subscriptions/analytics')">
              Analytics
            </a-menu-item> -->
            <a-menu-item key="Rules" @mouseenter="onSettingsHover('/subscriptions/rules')">
              Rules
            </a-menu-item>
            <a-menu-item key="List" @mouseenter="onSettingsHover('/subscriptions/list')">
              List
            </a-menu-item>
            <a-menu-item key="OrderList" @mouseenter="onSettingsHover('/subscriptions/orderList')">
              Order List
            </a-menu-item>
          </a-menu>
        </template>
        <a-button>
          <SettingOutlined/>
          Subscriptions
          <DownOutlined/>
        </a-button>
      </a-dropdown>

      <!-- Settings 下拉 -->
      <a-dropdown>
        <template #overlay>
          <a-menu @click="onSettingsMenuClick">
            <!-- <a-menu-item key="Account">
              Account
            </a-menu-item> -->
            <a-menu-item key="Payment" @mouseenter="onSettingsHover('/settings/payment')">
              Payment
            </a-menu-item>
            <a-menu-item key="Integrations" @mouseenter="onSettingsHover('/settings/integrations')">
              Integrations
            </a-menu-item>
            <!--            <a-menu-item key="SellingPlan" @mouseenter="onSettingsHover('/settings/selling-plan')">-->
            <!--              Selling Plan-->
            <!--            </a-menu-item>-->
            <!-- <a-menu-item key="PolicyManagement" @mouseenter="onSettingsHover('/settings/policy-management')">
              Policy Management
            </a-menu-item>
            <a-menu-item key="PolicyLink" @mouseenter="onSettingsHover('/settings/policy-link')">
              Policy Link
            </a-menu-item> -->
            <a-menu-item key="Settings" @mouseenter="onSettingsHover('/settings/settings')">
              Settings
            </a-menu-item>
          </a-menu>
        </template>
        <a-button>
          <SettingOutlined/>
          Settings
          <DownOutlined/>
        </a-button>
      </a-dropdown>
    </a-space>
    <a-space v-else>
      <div>

      </div>
    </a-space>

    <!-- 右侧状态 -->
    <a-space>
      <TemplateVersionTip />
      <a-button v-if="isFunnelDetail" @click="goBack">
        <LeftOutlined/>
        Back
      </a-button>
      <!-- Status for dashboard and root -->
      <Status v-if="showStatus" style="display: none;"/>

      <!-- Create Funnel button -->
      <CreateFunnel v-if="isPrefixActive('/funnels')"/>

      <SaveFunnel v-if="isPrefixActive('/funnel-')"/>

      <!-- Create Zone button -->
      <CreateZone v-if="isActive('/zones')"/>

      <!-- Integrations 页面改为模块内保存，不显示全局 Save -->
    </a-space>
  </a-row>
</template>

<script setup lang="ts">
import {computed, h, watch} from 'vue'
import {useRouter, useRoute} from 'vue-router'
import {useShopStore} from '@/store'
import {
  SettingOutlined,
  DownOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  GlobalOutlined,
  DeploymentUnitOutlined,
  LeftOutlined,
  ArrowLeftOutlined,
} from '@ant-design/icons-vue'
import Status from './header/Status.vue'
import CreateFunnel from './header/CreateFunnel.vue'
import SaveFunnel from './funnel/Save.vue'
import CreateZone from './header/CreateZone.vue'
import TemplateVersionTip from './header/TemplateVersionTip.vue'
import {getShopId} from '@/utils/shop'
import {prefetchRouteByPath} from '@/utils/routePrefetch'
import {useFunnelStore} from '@/store/modules/funnel'

const shopStore = useShopStore()
const funnelStore = useFunnelStore()
const router = useRouter()
const route = useRoute()

// 监听路由变化
watch(
    () => route.query.shop,
    () => {
      const shopId = getShopId(route);
      shopStore.setShopId(shopId);
    },
    {immediate: true}
);

const navs = [
  {key: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: h(AppstoreOutlined)},
  {key: 'reports', label: 'Reports', path: '/reports', icon: h(BarChartOutlined)},
  // {key: 'subscriptions', label: 'Subscriptions', path: '/subscriptions', icon: h(BarChartOutlined) },
  {key: 'zones', label: 'Checkout Zones', path: '/zones', icon: h(GlobalOutlined)},
  {key: 'funnels', label: 'Funnels', path: '/funnels', icon: h(DeploymentUnitOutlined)},
  // { key: 'helps', label: 'Helps', path: '/helps', icon: h(RocketOutlined) },
]

const showStatus = computed(() => {
  return route.path === '/' || route.path === '/dashboard'
})

const go = (path: string) => {
  // 保留当前路由的查询参数
  const currentQuery = {...route.query}
  router.push({path, query: currentQuery})
}

const isActive = (path: string) => route.path === path
const isPrefixActive = (prefix: string) => route.path.startsWith(prefix)

const isFunnelDetail = computed(() => /^\/funnel-(checkout-view|upsell-view|view)(-edit)?\/[^/]+(?:\/[^/]+)*$/.test(route.path))
const isUpsellEditor = computed(() => /^\/funnel-upsell-view\/[^/]+\/[^/]+$/.test(route.path))

const goBack = () => router.back()

// 导航悬停预加载
const onNavHover = (path: string) => {
  // 如果当前不在该路由，则预加载
  if (!isPrefixActive(path)) {
    prefetchRouteByPath(path)
  }
}

// Settings 菜单项悬停预加载
const onSettingsHover = (path: string) => {
  // 如果当前不在该路由，则预加载
  if (route.path !== path) {
    prefetchRouteByPath(path)
  }
}

const onSubscriptionsMenuClick = ({key}: { key: string }) => {
  console.log(`key===>${key}`)
  // 保留当前路由的查询参数
  const currentQuery = {...route.query}
  switch (key) {
    case 'Reports':
      router.push({path: '/subscriptions/reports', query: currentQuery})
      break
    case 'Analytics':
      router.push({path: '/subscriptions/analytics', query: currentQuery})
      break
    case 'Rules':
      router.push({path: '/subscriptions/rules', query: currentQuery})
      break
    case 'List':
      router.push({path: '/subscriptions/list', query: currentQuery})
      break
    case 'OrderList':
      router.push({path: '/subscriptions/orderList', query: currentQuery})
      break
  }
}


const onSettingsMenuClick = ({key}: { key: string }) => {
  // 保留当前路由的查询参数
  const currentQuery = {...route.query}

  switch (key) {
    case 'Account':
      router.push({path: '/settings/account', query: currentQuery})
      break
    case 'Payment':
      router.push({path: '/settings/payment', query: currentQuery})
      break
    case 'Integrations':
      router.push({path: '/settings/integrations', query: currentQuery})
      break
    case 'Settings':
      router.push({path: '/settings/settings', query: currentQuery})
      break
      // case 'SellingPlan':
      //   router.push({ path: '/settings/selling-plan', query: currentQuery })
      //   break
    case 'PolicyLink':
      router.push({path: '/settings/policy-link', query: currentQuery})
      break
    case 'PolicyManagement':
      router.push({path: '/settings/policy-management', query: currentQuery})
      break
  }
}
</script>

<style scoped>
.edit-topbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 4.8rem;
  padding: 0.8rem 1.6rem;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}

.edit-topbar-main {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.edit-title {
  margin: 0;
  font-size: 1.6rem;
  line-height: 1.25;
  font-weight: 700;
}

.edit-topbar-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.btn {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: #fff;
  color: #111827;
}

.btn--ghost:hover:not(:disabled) {
  border-color: #cbd5e1;
  background: #f9fafb;
}

.btn--back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.btn--primary {
  background: #111827;
  color: #fff;
  border-color: #111827;
}

.btn--primary:hover:not(:disabled) {
  background: #1f2937;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}

.dot.green {
  background: #52c41a;
}

.dot.red {
  background: #ff4d4f;
}

.dot.yellow {
  background: #faad14;
}
</style>
